import React from 'react';

export type ClientProductDisplay = {
  id: number;
  name: string;
  client_alias: string;
  ingredient_ids?: number[];
  is_explicit_filter_match?: boolean;
};

export const getClientProductDisplayText = (product: ClientProductDisplay) => {
  const alias = String(product?.client_alias || '').trim();
  const name = String(product?.name || '').trim();
  if (!alias) return name;
  if (!name) return alias;
  return `${alias} (${name})`;
};

const ClientProductDisplayLabel: React.FC<{
  product: ClientProductDisplay;
  secondaryColor?: React.CSSProperties['color'];
}> = ({ product, secondaryColor }) => {
  const alias = String(product?.client_alias || '').trim();
  const name = String(product?.name || '').trim();

  if (!alias) return <>{name}</>;

  return (
    <span>
      <span>{alias}</span>
      {name ? (
        <span style={{ color: secondaryColor ?? 'rgba(0, 0, 0, 0.45)', fontWeight: 400 }}>
          {' '}
          ({name})
        </span>
      ) : null}
    </span>
  );
};

export default ClientProductDisplayLabel;
